import { useState } from "react";
import Modal from "../modal/modal";
import { useForm } from "react-hook-form";
import { LoginFormValues } from '@erpsquad/common/runtime';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAuth } from '@erpsquad/common/runtime';
import { styled } from '@mui/material';
import { Box } from "@mui/material";
import Typography from "../typography/typography";
import DynamicInput from "../form-control/form-builder/form-builder-element/text";
import { Eye, EyeOff } from "../icons";
import Button from "../button/button";
import Toast from "../toast/toast";


const validationSchema = Yup.object({
  login: Yup.object({
      current_password: Yup.string().required("Please enter current password"),
      password: Yup.string()
                .required("Please enter password")
                .min(8, "Password must be at least 8 characters")
                .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character"),
      confirm_password: Yup.string().required("Please enter confirm password").oneOf([Yup.ref('password')], "Passwords must match"),
  }),
});



const ResetPasswordModal = ({showModal, setShowModal}) => {
     const { changeUserPassword } = useAuth();

    // const [showModal, setShowModal] = useState(false);
    const [toast, setToast] = useState<IToast | null>(null);

    interface FormValeus {
        login: LoginFormValues;
    }

    const { control, handleSubmit, trigger } = useForm<FormValeus>({
      resolver: yupResolver(validationSchema),
      mode: "all",
    });

    const onSubmit = async (values: FormValeus) => {
      const isValid = await trigger();
      if (!isValid) return;
      await changeUserPassword(values.login, (message, type) => {
        if (type) {
          setToast({ message: message, type: "normal" });
          setShowModal(false);
        } else {
          setToast({ message: message, type: "alert" });
        }
          // make logout
      });
      return values;      
    };

    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleShowPassword = () => setShowPassword(!showPassword);

    const [showCurrentPassword, setShowCurrentPassword] = useState<boolean>(false);
    const handleShowCurrentPassword = () => setShowCurrentPassword(!showCurrentPassword);

    const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
    const handleShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

     const FlexBox = styled(Box)(() => ({
        display: "flex",
        flexDirection: "column",
    }));

    return (
        <>
        <Modal 
        open={showModal}
        onClose={() => setShowModal(false)} 
        children={
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <FlexBox gap={4} className="popup-change-pass">
                  <FlexBox gap={2}>
                    <Box>
                      <Typography
                        align="center"
                        type="h1"
                        weight="medium"
                        color="theme.secondary.1000"
                      >
                        Change Password
                      </Typography>
                      <Typography
                        align="center"
                        type="h5"
                        weight="normal"
                        color="theme.secondary81000"
                      >
                        Enter Details below
                      </Typography>
                    </Box>
                    <FlexBox gap={2}>
                      <Box>
                        <DynamicInput
                          formControl={control}
                          label="Current Password"
                          name="current_password"
                          type={showCurrentPassword ? "text" : "password"}
                          placeholder="Enter Current Password"
                          fieldArrayName="login"
                          endIcon={
                            <>
                              {showCurrentPassword ? (
                                <Eye fontSize="small" htmlColor="#292D32" />
                              ) : (
                                <EyeOff fontSize="small" htmlColor="#292D32" />
                              )}
                            </>
                          }
                          onIconClick={handleShowCurrentPassword}
                        />
                      </Box>
                      <Box>
                        <DynamicInput
                          formControl={control}
                          label="Password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Password"
                          fieldArrayName="login"
                          endIcon={
                            <>
                              {showPassword ? (
                                <Eye fontSize="small" htmlColor="#292D32" />
                              ) : (
                                <EyeOff fontSize="small" htmlColor="#292D32" />
                              )}
                            </>
                          }
                          onIconClick={handleShowPassword}
                        />
                      </Box>
                      <Box>
                        <DynamicInput
                          formControl={control}
                          label="Confirm Password"
                          name="confirm_password"
                          type={showConfirmPassword ? "text" : "password"}
                          fieldArrayName="login"
                          endIcon={
                            <>
                              {showConfirmPassword ? (
                                <Eye fontSize="small" htmlColor="#292D32" />
                              ) : (
                                <EyeOff fontSize="small" htmlColor="#292D32" />
                              )}
                            </>
                          }
                          onIconClick={handleShowConfirmPassword} 
                          placeholder="Enter confirm password"
                        />
                      </Box>
                    </FlexBox>
                  </FlexBox>
                  <FlexBox gap={2}>
                    <Button type="button" onClick={handleSubmit(onSubmit)} size="large" variant="contained">
                      Change Password
                    </Button>
                  </FlexBox>
                </FlexBox>
              </form>          
          </>
        }
        />
        <Toast
            open={Boolean(toast)}
            message={toast?.message}
            type={toast?.type}
            handleClose={() => setToast(null)}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            autoHideDuration={3000}
            />
        </>
    );
}

export { ResetPasswordModal };
export default ResetPasswordModal;